import { compareStrings } from "@core/utils/array";

export enum HeatScore {
    NoData = 0,
    Declining = 1,
    Flat = 2,
    GainingSlow = 3,
    GainingFast = 4,
    OnFire = 5,
}

export enum HeatScoreColor {
    NoData = 'rgb(0, 0, 0)',
    Declining = 'rgb(130, 130, 130)',
    Flat = 'rgb(34, 149, 199)',
    GainingSlow = 'rgb(215, 156, 5)',
    GainingFast = 'rgb(245, 148, 83)',
    OnFire = 'rgb(245, 83, 83)',
}

export enum HeatScoreBgColor {
    NoData = 'rgb(255, 255, 255)',
    Declining = 'rgb(242, 242, 242)',
    Flat = 'rgb(220, 243, 254)',
    GainingSlow = 'rgb(255, 252, 239)',
    GainingFast = 'rgb(255, 238, 221)',
    OnFire = 'rgb(255, 236, 236)',
}

export const HEAT_SCORE_COLORS = {
    [HeatScore.Declining]: {
        color: HeatScoreColor.Declining,
        bgColor: HeatScoreBgColor.Declining,
    },
    [HeatScore.Flat]: {
        color: HeatScoreColor.Flat,
        bgColor: HeatScoreBgColor.Flat,
    },
    [HeatScore.GainingSlow]: {
        color: HeatScoreColor.GainingSlow,
        bgColor: HeatScoreBgColor.GainingSlow,
    },
    [HeatScore.GainingFast]: {
        color: HeatScoreColor.GainingFast,
        bgColor: HeatScoreBgColor.GainingFast,
    },
    [HeatScore.OnFire]: {
        color: HeatScoreColor.OnFire,
        bgColor: HeatScoreBgColor.OnFire,
    },
    [HeatScore.NoData]: {
        color: HeatScoreColor.NoData,
        bgColor: HeatScoreBgColor.NoData,
    },
};

export const HEAT_SCORE_ORDER = [
    HeatScore.OnFire,
    HeatScore.GainingFast,
    HeatScore.GainingSlow,
    HeatScore.Flat,
    HeatScore.Declining,
];

export function compareHeatScore(orderArray: HeatScore[], a?: HeatScore, b?: HeatScore): number {
    return compareStrings(
        orderArray,
        a ?? HeatScore.NoData,
        b ?? HeatScore.NoData
    );
}